import { useLayoutEffect, useState } from 'react';

/**
 * The width of an element, kept current with a ResizeObserver: for a layout that follows a card's
 * own width rather than the window's (the side menu takes part of the window). 0 until measured.
 */
export default function useElementWidth(ref) {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    const measure = (next) => setWidth((current) => (Math.round(next) === current ? current : Math.round(next)));
    measure(element.getBoundingClientRect().width);

    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (entry) {
        measure(entry.contentRect.width);
      }
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return width;
}
